export const ENV_DEV = 'development';
export const ENV_PROD = 'production';
export const validateNameRegex = /^[a-zA-Z0-9 ()@-]+$/;
export const getTimeIn12HRFormatRegex = /^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/;
export const CONFIRM_PROGRAM_DEACTIVATION = {
  title: 'Wallet plan deactivated!',
  message:
    'Any ongoing credit or future credit through this plan would stop immediately.',
};
export const genericErrorMsg = 'Oops! Something went wrong.';
export const wrongFormat = 'Upload a .csv not more than 5 MB';
export const paymentDetailsPendingInfo =
  'Payment details will be updated shortly. Please refresh';
export const paymentDetailsSuccessInfo = 'Payment successful!';
export const paymentDetailsFailedInfo = 'Payment failed';

export const emptyDashboardStateTitle = 'Welcome to Zomato for Enterprise';
export const emptyDashboardStateMessage = 'Get started by adding employees';
export const emptyEmployeesStateTitle = 'Get started by adding employees';
export const emptyProgramStateTitle =
  'Track and manage your meal plan activity here';
export const emptyPaymentsStateTitle =
  'Track all your transactions and payments activity here';
